module.exports = __webpack_public_path__ + "static/media/office-1.0298972c.jpg";